MemberState = require 'view-models/member-state'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/member_cards_filter'
track = require 'debug/track'

module.exports = class MemberCardsFilterPopOverView extends View
  viewTitleKey: 'filter cards'

  initialize: ->
    @listenTo MemberState, 'change:cardsPageFilter', ->
      @render()

  events:
    'click .js-set-filter': 'setFilter'

  render: ->
    @$el.html(template({
      filter: MemberState.getCardsPageFilter()
    }))

    @

  setFilter: (e) ->
    filter = @$(e.currentTarget).attr('data-filter')

    Util.stop(e)
    MemberState.setCardsPageFilter(filter)
    PopOver.hide()
    track("Member View", "Cards Page", "Filter", filter)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-filter-pop-over-view.coffee